import { cloneDeep } from 'lodash';
import {
    ConditionalElement,
    DraggableWorksheetFormComponent,
    FormElementFile,
    WorksheetElementAnswers,
} from '@packages/models/api';

const hasAssetContent = (file?: FormElementFile): boolean => {
    if (!file) {
        return false;
    }

    return Boolean(file.file || file.url || file.overlay?.file || file.overlay?.url);
};

const mergeFiles = (
    existingFile: (DraggableWorksheetFormComponent | ConditionalElement)['formElementFile'] | undefined,
    incomingFile: FormElementFile | undefined
) => {
    const mergedFile = { ...(existingFile || {}), ...(incomingFile || {}) };

    if (incomingFile) {
        if (!incomingFile.overlay) {
            delete mergedFile.overlay;
        } else {
            mergedFile.overlay = incomingFile.overlay;
        }
    }

    if (!hasAssetContent(incomingFile)) {
        mergedFile.file = undefined;
        mergedFile.url = undefined;
        mergedFile.name = mergedFile.name || '';
        if (mergedFile.overlay) {
            delete mergedFile.overlay;
        }
    }

    return mergedFile;
};

export const mergeAnswerFileIntoElements = (
    elements: DraggableWorksheetFormComponent[],
    answer: WorksheetElementAnswers
): { updatedElements: DraggableWorksheetFormComponent[]; changed: boolean } => {
    if (!answer?.elementId) {
        return { updatedElements: elements, changed: false };
    }

    const clonedElements = cloneDeep(elements);
    let changed = false;

    const applyAnswerToElements = (items: (DraggableWorksheetFormComponent | ConditionalElement)[]): boolean => {
        return items.some((element) => {
            if (element.formElementId === answer.elementId) {
                element.formElementFile = mergeFiles(element.formElementFile, answer.asset?.answerFile);
                changed = true;
                return true;
            }

            if (element.optionConditionsElements?.length) {
                return applyAnswerToElements(element.optionConditionsElements);
            }

            return false;
        });
    };

    applyAnswerToElements(clonedElements);

    return {
        updatedElements: changed ? clonedElements : elements,
        changed,
    };
};

export default mergeAnswerFileIntoElements;
